// Footer


const Footer = () => {
    
    return (
                    
        <footer>
            <p>Created by Sabine Tait at <a href="https://junocollege.com/">Juno College</a> 2022</p>
        </footer>

    )
}

export default Footer;